
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Upload } from 'lucide-react';

interface SundayMarketPricesHeaderProps {
  onAddNew: () => void;
  onUpload: () => void;
}

const SundayMarketPricesHeader: React.FC<SundayMarketPricesHeaderProps> = ({ 
  onAddNew, 
  onUpload 
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Sunday Market Prices</h2>
        <p className="text-gray-600">Manage Sunday market price data collection</p>
      </div>
      <div className="flex gap-3">
        <Button onClick={onUpload} variant="outline" className="flex items-center gap-2">
          <Upload className="h-4 w-4" />
          Upload Excel
        </Button>
        <Button onClick={onAddNew} className="flex items-center gap-2">
          <Plus className="h-4 w-4" />
          Add New Price
        </Button>
      </div>
    </div>
  );
};

export default SundayMarketPricesHeader;
